// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__1KyiS","moveRightAll":"Nav_moveRightAll__lcN5m","links":"Nav_links__3v4Eq"};